import { Toast } from 'antd-mobile';
import { coinsBattleInfo, coinsBattleDraw, coinsBattleFloatScreen, coinsBattleGetRecord, coinsBattleCloseDialog, coinsBattleJackpotInfo } from '@/services/activity';

export default {
  namespace: 'coinsBattle',
  state: {
    status: 0,
    countDown: 0,
    title: '',
    titleUrl: '',
    rules: '',
    coinsJackpotValue: 0,
    drawTimeList: [],
    remainDrawCount: 0,
    rechargeValueToDraw: 0,
    remainRechargeValue: 0,
    totalRechargeCoins: 0,
    showRulesDialog: 0,
    showWelfareDialog: 0,
    drawRewardList: [],
    taskList: [],
    normalRewardList: [],
    jackpotRewardList: [],
    pageNum: 1,
    pageSize: 20,
    isMore: false,
    timeIsMore: false,
    recordList: [],
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        status: payload.status || 0,
        countDown: payload.countDown || 0,
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        rules: payload.rules || '',
        drawTimeList: payload.drawTimeList || [],
        remainDrawCount: payload.remainDrawCount || 0,
        rechargeValueToDraw: payload.rechargeValueToDraw || 0,
        remainRechargeValue: payload.remainRechargeValue || 0,
        totalRechargeCoins: payload.totalRechargeCoins || 0,
        showRulesDialog: payload.showRulesDialog || 0,
        showWelfareDialog: payload.showWelfareDialog || 0,
        drawRewardList: payload.drawRewardList || [],
      };
    },
    updateDrawInfo(state, { payload }) {
      return {
        ...state,
        totalRechargeCoins: payload.totalRechargeCoins || 0,
        remainDrawCount: payload.remainDrawCount || 0,
        coinsJackpotValue: payload.coinsJackpotValue || 0,
        normalRewardList: payload.normalRewardList || [],
        jackpotRewardList: payload.jackpotRewardList || [],
      };
    },
    updateList(state, { payload }) {
      let list = payload.force ? [] : [...state.recordList];
      if (payload.record && payload.record.length) {
        list = [...list, ...payload.record];
      }
      let type1More = false;
      let type2More = false;
      if (payload && payload.type === 1) {
        type1More = payload.record && payload.record.length > 0 ? true : false;
        type2More = false;
      }
      if (payload && payload.type === 2) {
        type2More = payload.record && payload.record.length > 0 ? true : false;
        type1More = false;
      }
      return {
        ...state,
        recordList: list || [],
        pageNum: payload.pageNum,
        isMore: type1More,
        timeIsMore: type2More,
      };
    },
    updateJackpotInfo(state, { payload }) {
      return {
        ...state,
        coinsJackpotValue: payload.coinsJackpotValue || 0,
        taskList: payload.taskList || [],
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(coinsBattleInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return data;
    },
    *closeDialog({ payload }, { call, put }) {
      const { error, data } = yield call(coinsBattleCloseDialog, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
          code,
        };
      } else {
        return {
          data,
          success: true,
        };
      }
    },
    *draw({ payload }, { call, put }) {
      const { error, data } = yield call(coinsBattleDraw, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
        };
      }
      yield put({
        type: 'updateDrawInfo',
        payload: data,
      });
      return {
        success: true,
        data,
      };
    },
    *getFloatList({ payload }, { call }) {
      const { error, data } = yield call(coinsBattleFloatScreen, payload);
      if (error) {
        return {
          error,
          success: false,
        };
      }
      if (data) {
        return {
          success: true,
          data: data.length ? data : [],
        };
      } else {
        return false;
      }
    },
    *getList({ payload }, { call, put, select }) {
      const { pageNum, pageSize } = yield select(state => state.coinsBattle);
      const { error, data } = yield call(coinsBattleGetRecord, { ...payload, pageNum: payload.force ? 1 : pageNum, pageSize: pageSize, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateList',
        payload: { record: data, pageNum: payload.force ? 2 : pageNum + 1, force: payload.force, type: payload.type },
      });
      return true;
    },
    *getJackpotInfo({ payload }, { call, put }) {
      const { error, data } = yield call(coinsBattleJackpotInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateJackpotInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateJackpotInfo',
        payload: data,
      });
      return data;
    },
  },
};
